import { defaultSiteContent } from './default-content.js';
/**
 * Fill in anything a stored document is missing from the baked-in defaults.
 *
 * Published/draft documents in blob storage were written against whatever
 * the content model looked like at publish time, so a document written
 * before a field existed would otherwise render as blank. Object-valued
 * sections are merged one level deep; arrays are taken wholesale (a
 * deliberately emptied list must stay empty).
 */
export function withContentDefaults(stored) {
    if (!stored)
        return defaultSiteContent;
    return {
        ...defaultSiteContent,
        ...stored,
        hero: { ...defaultSiteContent.hero, ...stored.hero },
        addOn: { ...defaultSiteContent.addOn, ...stored.addOn },
        contractBasics: { ...defaultSiteContent.contractBasics, ...stored.contractBasics },
        about: { ...defaultSiteContent.about, ...stored.about },
        contact: { ...defaultSiteContent.contact, ...stored.contact },
        footer: { ...defaultSiteContent.footer, ...stored.footer },
    };
}
//# sourceMappingURL=normalize.js.map